import { render, staticRenderFns } from "./AutofillReference.vue?vue&type=template&id=45bb6873&scoped=true"
import script from "./AutofillReference.vue?vue&type=script&lang=js"
export * from "./AutofillReference.vue?vue&type=script&lang=js"
import style0 from "./AutofillReference.vue?vue&type=style&index=0&id=45bb6873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb6873",
  null
  
)

export default component.exports